import React from 'react'
import CustomInput from 'Common/CustomInput/CustomInput'
import MaskPhoneNumber from 'Utils/MaskPhoneNumber';
import { useSelector } from 'react-redux';
 

const Profile = ({ profileData , validationModel , onHandleChange}) => {
    const { userinfo } = useSelector((state) => state.userAuth);
    return (
        <div className='grid grid-cols-2 gap-4'>
            <div>
                <CustomInput name="firstName" value={profileData.firstName} onChange={onHandleChange} required label="First Name" placeholder="First Name" />
            </div>
            <div>
                <CustomInput name="lastName" value={profileData.lastName} onChange={onHandleChange} required label="Last Name" placeholder="Last Name" />
            </div>
            <div>
                <CustomInput name="email" value={userinfo.userEmail} required label="Email" placeholder="abc@gmail.com" disabled />
            </div>
            <div>
                <CustomInput name="phoneNumber" onChange={onHandleChange} required label="Phone" value={MaskPhoneNumber(profileData.phoneNumber,"generatemask")}
                      placeholder="(123) 456-7896" />
                {validationModel.phoneError}
            </div>
        </div>
    )
}

export default Profile